export class OrderInformation {
    Amount: number;
    Currency: string;
    OrderNumber: string;
    OrderDescription: string;
    Fee: number;
    RoundingAmount: number;
    Total: number;
    TimeStamp:string;
}

export class TerminalInformation {
    CustomerEntered: string;
    CustomerRedirected: string;
    Browser: string;
}

export class CardInformation {
    PaymentMethod: string;
}

export class PaymentInformation {
    ErrorLog: string;
    QueryFinished: string;
    PaymentMethod: CardInformation;
    TerminalInformation: TerminalInformation;
    OrderInfo: OrderInformation;
    ErrorMessage: string;
    HasError: boolean;
}


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/paymentInfo.ts